import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import fetchAll from "../../../helpers/fetchAll";
import {
  FETCH_RECEIVABLENOTES_FAILURE,
  FETCH_RECEIVABLENOTES_REQUEST,
  FETCH_RECEIVABLENOTES_SUCCESS
} from "../types";
import { addEntities } from "../../entities";

const fetchReceivableNotes = id => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(FETCH_RECEIVABLENOTES_REQUEST)({}));
    const response = await fetchAll(() => api.factoring.getReceivableNotes(id));

    const data = normalize(response, [schema.notes]);

    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_RECEIVABLENOTES_SUCCESS)({ [id]: data.result })
    );
  } catch (err) {
    dispatch(createAction(FETCH_RECEIVABLENOTES_FAILURE)(err));
    throw err;
  }
};

export default fetchReceivableNotes;
